import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BASIC } from 'styles/spacingPresets';
import Box from 'components/Box';
import Card from 'components/Card';
import Icon from 'components/Icon';
import PageTitle from 'components/PageTitle';
import InlineList from 'components/InlineList';
import Pill from 'components/Pill';
import TextLink from 'components/TextLink';
import TooltipButton from 'components/TooltipButton';
import { NavMenu, NavMenuButton, NavMenuList } from 'components/NavMenu';
import Flex from 'components/Flex';
import ScrollableNav from 'components/ScrollableNav';
import { CloseButton } from 'components/EditorPageHeader';
import useBreakpoints from 'hooks/useBreakpoints';
import useUniqueId from 'hooks/useUniqueId';
function MultipleSelectionHeader(_ref) {
  var title = _ref.title,
    providedTitleId = _ref.titleId,
    selection = _ref.selection,
    menuItems = _ref.menuItems,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    children = _ref.children,
    navigationLabel = _ref.navigationLabel,
    cardVariant = _ref.cardVariant,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useBreakpoints = useBreakpoints('m'),
    isDesktop = _useBreakpoints.m;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    shouldTrimList = _useState2[0],
    setShouldTrimList = _useState2[1];
  var titleId = providedTitleId || uniqueId;
  var selectionToShow = shouldTrimList ? selection.slice(0, 3) : selection;
  return /*#__PURE__*/React.createElement(Card, {
    as: "header",
    variant: cardVariant,
    position: "relative",
    pl: BASIC.LARGE,
    pr: "m",
    pt: BASIC.SMALL,
    breakpoints: BASIC.BREAKPOINTS,
    pb: children ? undefined : 's',
    overflow: "visible",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    id: titleId
  }, title)), (menuItems || onClose) && /*#__PURE__*/React.createElement(Box, {
    mt: "-xxs",
    mr: onClose ? '-xs' : '-s'
  }, menuItems && /*#__PURE__*/React.createElement(NavMenu, {
    id: "-multi-more-options-menu",
    menuPlacement: "bottom-end"
  }, /*#__PURE__*/React.createElement(NavMenuButton, {
    variant: "transparent",
    iconRight: "tools",
    iconOnly: !isDesktop
  }, t('actions_more_options')), /*#__PURE__*/React.createElement(NavMenuList, null, menuItems)), onClose && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose
  }))), /*#__PURE__*/React.createElement(Box, {
    fontSize: "s",
    mb: children && !actions.length ? undefined : 's',
    mt: "xs"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs",
    "aria-labelledby": titleId
  }, selectionToShow.map(function (item) {
    return /*#__PURE__*/React.createElement(Pill, {
      key: item.id
    }, item.name);
  }), selection.length > 3 && /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: "button",
    onClick: function onClick() {
      return setShouldTrimList(function (prev) {
        return !prev;
      });
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 0.93,
    name: shouldTrimList ? 'plus' : 'minus',
    mt: -2,
    mr: "xxxs"
  }), shouldTrimList ? t('actions_more_count', {
    count: selection.length - 3
  }) : t('actions_show_less')))), actions.length > 0 && /*#__PURE__*/React.createElement(Box, {
    mt: "m"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs"
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement(TooltipButton, {
      key: action.title,
      title: action.hint,
      size: "medium",
      onClick: action.onClick,
      isDisabled: action.isDisabled
    }, action.title);
  }))), children && /*#__PURE__*/React.createElement(ScrollableNav, {
    navigationLabel: navigationLabel
  }, children));
}
export default MultipleSelectionHeader;